<template>
  <PageWrapper v-once>
    <container>
      <SectionHeader>
        <h1>TERMS AND CONDITIONS</h1>
        <h2>Updated: 25.8.2021</h2>
      </SectionHeader>
      <Divider size="2em" />
      <SectionWrapper class="whiteframe shadowframe">
        <article>
          <h2>In these Terms and Conditions</h2>

          <p>
            "Company", “We”, “Us” means BOHEMIA INTERACTIVE a.s. residing at
            Stříbrná Lhota 747, 252 10 Mníšek pod Brdy, Czech Republic,
            registered in the Commercial Register kept by the Municipal Court in
            Prague, section B, insert 9791 (Id.No.: 272 18 864, DIČ: CZ 272 18
            864) and its affiliates and subsidiaries.<br />
            "User", “You” means the person, company or institution that uses the
            Services<br />
            “Services” are services, games and websites operated by the Company
            and used by the User.
          </p>

          <h2>Your Privacy</h2>

          <p>
            Privacy is an issue that We know is important to You and therefore
            it is very important to Us as well. That is why We have created
            separate dedicated documents
            <a href="http://www.bistudio.com/privacy-policy" target="_blank"
              >Privacy policy</a
            >
            and
            <a href="http://www.bistudio.com/cookie-policy" target="_blank"
              >Cookies policy</a
            >, which describe how We collect, handle and protect Your personal
            information. Both Privacy Policy and Cookies policy are part of
            these Terms and Conditions and so by agreeing to these Terms and
            conditions You also agree to all parts of these two policies, so
            please read them carefully.
          </p>

          <h2>Terms of usage</h2>

          <p>
            You agree not to use any false, inaccurate or misleading information
            when registering to using the Services. Some of our Services may
            require username and password, which You will have to create in
            order to use these Services. This username and password is private
            and You must keep them safe and change Your password often. If You
            let someone find out Your username and password, You remain
            responsible for any actions they may undertake.
          </p>

          <p>
            By agreeing to these Terms and Conditions You represent that You are
            13 years of age or older, that You have fully understood it and that
            You are capable of accepting it. Otherwise please ask Your legal
            guardian (usually Your parent) to review these Terms and agree on
            Your behalf.
          </p>

          <p>
            If You are the legal guardian of a User that creates a Bohemia
            account, You agree to these Terms on the User’s behalf and are
            responsible for all use of the Bohemia account or Services
            (including purchases).
          </p>

          <h2>No Warranty</h2>

          <p>
            THE SERVICES ARE TO BE CONSIDERED PROVIDED AS IS. WE OFFER NO
            WARRANTY OR GUARANTEE OF COMPLETION OR ACCURACY OR EXPEDIENCY AS IS
            APPLICABLE UNDER THE RELEVANT LAW. WARRANTY OF OWNERSHIP, TITLE,
            CAPABILITY FOR A SPECIFIC PURPOSE AND NON-LEGAL INFRINGEMENT IS
            EXPRESSLY DISCLAIMED. ACCESS TO THE SERVICES IS NOT GUARANTEED TO BE
            A CONSTANT. USERS DOWNLOADING OR IN ANY OTHER WAY OBTAINING ANY
            CONTENT OF ANY KIND FROM THE SERVICES DO SO AT THEIR OWN RISK AND
            USERS WILL THEMSELVES BE RESPONSIBLE FOR ANY DATA LOSS OR OTHER
            DAMAGE THAT IS A SUBSEQUENT CONSEQUENCE OF ANY DOWNLOADING OR OTHER
            ACTIVITY USING THE SERVICES. THE LAWS OF CERTAIN COUNTRIES, REGIONS,
            PROVINCES, STATES OR COUNTIES MAY NOT ALLOW THE DISCLAMATION OF
            CERTAIN ELEMENTS OF FUNDAMENTAL WARRANTY RESULTING IN PORTIONS OF
            THE ABOVE NOT APPLYING TO THE VISITOR. THEREFORE THE WARRANTY
            APPLIED IS LIMITED TO THAT WHICH IS PERMISSIBLE UNDER ANY AND ALL
            APPLICABLE LAW.
          </p>

          <h2>Limitation of Liability</h2>

          <p>
            USE OF OUR CONTENT OR SERVICES IS EXERCISED SOLELY AT THE SPECIFIC
            RISK OF THE USER AS IS ULTIMATELY APPLICABLE UNDER THE RELEVANT LAW
            OF THE COUNTRY, STATE, PROVINCE OR COUNTY OF THE USER. WE SHALL BEAR
            NO RESPONSIBILITY OR LIABILITY FOR ANY DAMAGES OF ANY KIND INCURRED
            FROM THE USE OF THE SERVICES. WE SHALL ALSO BEAR NO RESPONSIBILITY
            FOR ANY DAMAGES OR COSTS INCURRED THROUGH ACCESS TO THE SERVICES TO
            THE MAXIMUM EXTENT PERMITTED BY THE RELEVANT LAW OF THE COUNTRY,
            STATE, PROVINCE OR COUNTY OF THE USER.
          </p>

          <h2>Termination and Limitation of Access</h2>

          <p>
            The right to access or use our Services is strictly held by Us and
            We reserve the right to remove or limit Your access to the Services
            for any or no reason.
          </p>

          <h2>Severability</h2>

          <p>
            Should any or all terms or provisions be considered illegal or
            unenforceable by an appropriate and agreed court or jurisdiction
            then the terms or provisions shall be amended as much as is
            necessary to retain their intent whilst making them enforceable. If
            amendment is not possible then the specific terms of provisions
            which are beyond agreement shall be removed whilst retaining in full
            force all other provisions or terms of use.
          </p>

          <h2>Contributions to Our Services</h2>

          <p>
            We try to continually improve Our Services based on the feedback of
            Our Users which We highly appreciate. Please, note that once You
            send Us any feedback via our Feedback Tracker or any other media or
            Services or once You post anything publicly within Our Services You
            grant Us a perpetual, worldwide, unlimited, royalty-free license to
            use such information to improve Our Services. Please, also note that
            your public posts within Our Services can be accessed by other Users
            and used by them and can be removed only by Us in Our sole
            discretion.
          </p>

          <h2>Miscellaneous</h2>

          <p>
            These Terms and Conditions form the complete agreement between You
            and Us regarding usage of and access to the Services. Some of the
            Services may be subject to Special terms, e.g. EULA, which amend
            Terms and Conditions of this particular service. In case of a
            collision the Special terms prevail. This agreement shall supersede
            any and all previous agreements of any nature between You and Us
            regarding and respecting the Services.
          </p>

          <p>
            We reserve the right to make changes to these Terms and Conditions
            at any time. You will be subject to the Terms and Conditions at all
            times during which You are using the Services.
          </p>

          <p>
            These Terms and Conditions are governed by and construed in
            accordance with the laws of the Czech Republic and both You and Us
            hereby submit to the exclusive jurisdiction of the Courts of the
            Czech Republic.
          </p>
        </article>
      </SectionWrapper>
    </container>
  </PageWrapper>
</template>

<script>
export default {
  name: "terms-and-conditions",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
